// extracted by mini-css-extract-plugin
export default {"mainCard":"SupportCard_mainCard__I5Uzl"};